var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFiltercopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#filter_copy_svg__clip0)",
    fill: "#797584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8h2v4H8V8zm2-6.816V0H8v1.184a3 3 0 102 0zM9 5a1 1 0 110-2 1 1 0 010 2zM2 0h2v4H2V0zm1 5a2.993 2.993 0 00-1 5.816V12h2v-1.184A2.993 2.993 0 003 5zm0 4a1 1 0 110-2 1 1 0 010 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filter_copy_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgFiltercopy;